.kn{right:0.25rem;}